import { useQuery } from "@tanstack/react-query";
import { OrderItemFragment } from "~/queries/fragments/order-item";
import { OrderSummaryFragment } from "~/queries/fragments/order-summary";
import { gqlReqAll } from "~/libs/gql";
import { GetPrepStationsOrdersDocument } from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		query GetPrepStationsOrders {
			serverTime
			getOperationalOrders {
				...OrderSummaryFragment
				items {
					...OrderItemFragment
					kds_accepted_at
					kds_held_at
					kds_held_ms
					cancelled_at
				}
			}
		}
		${OrderSummaryFragment}
		${OrderItemFragment}
	`
);

export const getPrepStationsOrdersQueryKey = () => ["getPrepStationsOrders"];

export const getPrepStationsOrdersQueryFn = async (signal?: AbortSignal) => {
	const response = await gqlReqAll({
		document: GetPrepStationsOrdersDocument,
		signal,
	});
	return {
		orders: response.getOperationalOrders,
		serverTimeOffset: new Date(response.serverTime).getTime() - Date.now(),
	};
};

export const useGetPrepStationsOrders = (enabled = true) => {
	return useQuery({
		enabled,
		refetchInterval: 15_000,
		queryKey: getPrepStationsOrdersQueryKey(),
		queryFn: ({ signal }) => getPrepStationsOrdersQueryFn(signal),
	});
};
